import { navItems, profile } from "../data/content";
import { Github, Linkedin } from "./Icons";
import "./Footer.css";

export function Footer() {
  const goTo = (id) => (event) => {
    event.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <span className="footer__name">{profile.name}</span>
          <span className="footer__role">{profile.role}</span>
        </div>

        <nav className="footer__links" aria-label="Navegação do rodapé">
          {navItems.map((item) => (
            <a key={item.id} href={`#${item.id}`} onClick={goTo(item.id)}>
              {item.label}
            </a>
          ))}
        </nav>

        <div className="footer__socials">
          <a
            href={profile.github}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
          >
            <Github size={17} />
          </a>
          <a
            href={profile.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <Linkedin size={17} />
          </a>
        </div>
      </div>

      <div className="container footer__bottom">
        <span>© {new Date().getFullYear()} {profile.name}. Todos os direitos reservados.</span>
        <span className="footer__built">Feito com React e muito café.</span>
      </div>
    </footer>
  );
}
